import React, { useState, useEffect, useRef } from 'react'
import './index.less'
import { queryShareUserRelation } from '../../api'
import SharingUserItem from '../../components/sharing-user-item'
import { getParamsFromHash } from '../../../../utils/common'
import SharingRemoveModal from '../../components/sharing-remove-modal'
import LoadingPage from '../../../../components/loading-page'
import Empty from '../../components/empty'
import { trackGdp } from '../../../../utils/gio-report'
import { queryCurrentUserBasicInfo } from '../../../../api/pile-sharing'
import { UserTypeEnum } from '../../../../api/pile'
import { PILE_SHARING_FORM_KEY } from '../../../../utils/constants';
import { useThrottleFn } from 'ahooks'
const pageSize = 10
const UserList = () => {
    const [userList, setUserList] = useState<any[]>([])
    const [userListPageNo, setUserListPageNo] = useState<number>(1)
    const [userListTotal, setUserListTotal] = useState<number>(0)
    const [sharingRemoveVisible, setSharingRemoveVisible] = useState<boolean>(false)
    const [removeItem, setRemoveItem] = useState<any>({})
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const userListRef = useRef(null)
    const loading = useRef(false)
    const [userInfo, setUserInfo] = useState<any>({})
    //获取用户登录信息
    const getUser = () => {
        queryCurrentUserBasicInfo().then(({ data }) => {
            setUserInfo(data)
            // 上报埋点
            trackGdp('P20076', 'B001', {
                userId: data?.uid,
                userType: UserTypeEnum[data?.type],
                user_type: UserTypeEnum[data?.type]
            })
            // 切换用户后清除缓存
            console.log(localStorage.getItem('pileSharingUid') != data.uid, '切换用户');

            if (localStorage.getItem('pileSharingUid') != data.uid) {
                localStorage.removeItem('pileSharingAgree')
                localStorage.removeItem(PILE_SHARING_FORM_KEY)
                localStorage.removeItem('pileSharingStationId')
                localStorage.removeItem('pileUseInfo')
            }
        }).finally(() => {
            initPage()
        })
    }
    useEffect(() => {
        getUser()
    }, [])
    const initPage = async (pageNo?: number, refresh?: boolean) => {
        if (loading.current) {
            return
        }
        loading.current = true
        try {
            if (refresh) { setIsLoading(true) }
            let { data } = await queryShareUserRelation({ stationId: getParamsFromHash('stationId'), pageNo: pageNo || 1, pageSize })
            if (data?.records?.length) {
                setUserList((pageNo && pageNo !== 1) ? userList.concat(data.records) : data.records)
                setUserListTotal(data?.total)
            } else {
                setUserList([])
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error)
        } finally {
            loading.current = false
        }

    }

    const remove = (item: any) => {
        setRemoveItem(item)
        // 上报埋点
        trackGdp('P20076', 'B002', {
            userId: userInfo?.uid,
            userType: UserTypeEnum[userInfo?.type],
            user_type: UserTypeEnum[userInfo?.type]
        })
        setSharingRemoveVisible(true)
    }
    const onUserListScroll = () => {
        const listDom: any = userListRef.current;
        if (listDom) {
            console.log(listDom.scrollHeight, listDom.clientHeight, listDom.scrollTop, 'height count');
            const isEnd =
                listDom.scrollTop + 50 >= listDom.scrollHeight - listDom.clientHeight;
            console.log(isEnd, 'isEnd')
            if (isEnd) {
                console.log(userListPageNo * pageSize, userListTotal);
                // 已经到底了
                if (userList.length >= userListTotal) {
                    return;
                }
                let nextPage = userListPageNo + 1;
                // 如果计算出来的数据量比已有的数据还多，说明上一次还没加载成功，重新来
                if (userListPageNo * pageSize > userList.length) {
                    nextPage = userListPageNo;
                }
                setUserListPageNo(nextPage)
                initPage(nextPage)
            }
        }
    };
    const { run } = useThrottleFn(onUserListScroll, { wait: 100 });

    if (isLoading) {
        return (
            <div className='user-list-container'>
                <LoadingPage />
            </div>
        )
    }

    return <div className='user-list-container' onScroll={run} ref={userListRef}>
        {
            userList.length
                ?
                userList.map((item, index) => {
                    return <SharingUserItem onRemove={() => remove(item)} key={index} data={item} />
                })
                :
                <div className='user-list-empty'>
                    <Empty text='邀请别人来充电，共享低碳生活' />
                </div>
        }
        <SharingRemoveModal
            visible={sharingRemoveVisible}
            setVisible={(status) => setSharingRemoveVisible(status)}
            data={removeItem}
            refresh={() => initPage(1, true)}
            userInfo={userInfo}
        />
    </div>
}

export default UserList